import certificate01 from '../Images/certificate01.png'
import certificate02 from '../Images/certificate02.png'
import certificate03 from '../Images/certificate03.png'
import certificate04 from '../Images/certificate04.png'
import certificate05 from '../Images/certificate05.png'
import certificate06 from '../Images/certificate06.png'

const certificates = {
  imgs: [
    certificate06,
    certificate05,
    certificate04,
    certificate03,
    certificate02,
    certificate01,
  ],
  links: [
    "https://www.credential.net/31966a28-b7fe-4bcf-93bc-74fa7375fe25#gs.y3x6di",
    "https://www.credential.net/7ee6a5f5-7990-446c-9272-990fae207d9b#gs.weq5jd",
    "https://www.credential.net/a01c50e8-c627-4e96-9864-6888ef7b353a#gs.rddmr2",
    "https://www.credential.net/b766345a-b5d5-4494-a2e8-1e1b42a171ba",
    "https://www.credential.net/86b5d440-77b1-4631-8559-b6fb45eb657b",
    "https://smartcerts.co/certificate/xjvwlppy"
  ]
}

export default certificates